// Import getParamValue from the leaf module (not the `@/util` barrel) to avoid a
// plugin → @/util → … → store → plugin import cycle (import/no-cycle).
import { getParamValue } from '@/utils/url.utils'
import { ROUTE_NAMES } from '@/constant/routes'

// BOO-630 / AHA-46571: marketplace buyers (AppSumo/StackCommerce) arrive via a
// special auth link (?redeemLicenseKey=true). A buyer who already has a (free)
// account will log IN rather than sign up, so the redeem intent must survive both
// paths. Instead of adding a routing branch to the already-huge handleRegisterSuccess
// / login methods, this plugin subscribes to the sign-up AND log-in success lifecycle
// hooks and, when redeem applies, performs its OWN post-auth navigation. Those auth
// methods only fire the hook and own none of this — new post-auth behaviours are new
// subscribers here, never new `if` blocks there, and each subscriber is free to
// navigate however it wants (push, replace, external redirect, ...).
//
// The hook is dispatched last in each auth method, so this navigation lands after the
// default cascade and wins. router / mixpanel are lazy-required inside the hook to
// avoid a plugin → router → … → store → plugin import cycle; by the time the hook
// runs the store, router and auth are all initialised.
const AUTH_SUCCESS_ACTIONS = new Set(['signUpSuccessAction', 'logInSuccessAction'])

const marketplaceRedeemPlugin = (store) => {
  store.subscribeAction({
    after: (action) => {
      if (!AUTH_SUCCESS_ACTIONS.has(action.type)) return

      const flagOn = store.getters['featureToggles/canUseLifetimeOnMarketplace']
      const wantsRedeem = getParamValue('redeemLicenseKey', window.location.href) === 'true'
      if (!flagOn || !wantsRedeem) return

      // eslint-disable-next-line global-require
      const router = require('@/router').default
      // eslint-disable-next-line global-require
      const MixpanelUtils = require('@/utils/mixpanel.utils').default

      MixpanelUtils.trackPostSignupRoute('marketplace-redeem')
      // Route to the redeem screen first; onboarding runs AFTER redeem or skip
      // (RedeemCodePage owns that next hop via the `flow: onboarding` query). This
      // plugin chooses its own navigation — here push; another could use replace.
      router.push({ name: ROUTE_NAMES.REDEEM, query: { flow: 'onboarding' } }).catch(() => {})
    },
  })
}

export default marketplaceRedeemPlugin
